import { useState, useEffect } from 'react';
import { TopToolbar, useRecordContext, AutocompleteInput, ExportButton, Button, List, Datagrid, TextField, EmailField, TextInput, ReferenceInput, SelectInput, ReferenceField, Edit, SimpleForm, useGetList, useDataProvider, Create, required, DateTimeInput, DateField } from 'react-admin';
import IconAdd from '@mui/icons-material/Add';

import * as React from 'react';
import Box from '@mui/material/Box';
//import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';

import {default as MUITextField} from '@mui/material/TextField';
import {default as MUIButton} from '@mui/material/Button';
import {default as MUIMenuItem} from '@mui/material/MenuItem';
import {default as MUISelect} from '@mui/material/Select';
import {default as FormControl} from '@mui/material/FormControl';

import {fetcherGetSync, fetcherSync} from "../utils/fetcher";
import config from "../config";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

const buttonContainer = {
    textAlign: "center",
    marginTop: "20px"
}

const buttonStyle = {
    marginLeft: "10px",
    marginRight: "10px",
}

const addProduct = (orderId, productId, count, handleClose) => {
    var res = fetcherSync(config.API_HOST+"/orderProducts", "POST", {
        orderId: orderId,
        productId: productId,
        count: count
    });
    setTimeout(() => window.location.reload(), 1000);
}

export default function OrderProductModalCreate(props) {
    const record = useRecordContext();
    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const [count, setCount] = React.useState(0);
    const [productId, setProductId] = React.useState(10);
    const [productsNotInOrderElement, setProductsNotInOrderElement] = React.useState([]);

    useEffect(() => {

        if(record != undefined){
            let familiesInCatalog = fetcherGetSync(config.API_HOST+"/users/"+record.clientId+"/catalog");
            
            let productsIdsInOrder = record.productsIds;

            let familyWithProductsNotInOrder = familiesInCatalog
                .map(family => {
                    family.products = family.products.filter(e => !productsIdsInOrder.includes(e.id));
                    return family;
                });
            familyWithProductsNotInOrder = familyWithProductsNotInOrder.filter(family => family.products.length > 0);

            let productsElementList = [];
            for(let family of familyWithProductsNotInOrder){
                for(let product of family.products){
                    productsElementList.push(<MUIMenuItem value={`${product.id}`}>{product.product}</MUIMenuItem>)
                }
            }
            setProductsNotInOrderElement(productsElementList);
        }
            
    }, [record]);

    return (
        <div>
            <Button
                onClick={() => { handleOpen() }}
                label="Ajouter un produit"
                style={{width: "100%", textAlign: "center"}}
            >
                <IconAdd/>
            </Button>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Typography id="modal-modal-title" variant="h6" component="h2">
                        Ajouter un produit à la commande
                    </Typography>

                    <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                        Produit pas dans la commande :
                    </Typography>
                    <MUISelect
                        value={productId}
                        onChange={(e) => setProductId(e.target.value)}
                        label="Produit"
                        style={{width: 200}}
                    >
                        {productsNotInOrderElement.map(function(d, idx){
                            console.log("d");
                            console.log(d);
                            return d
                        })}
                    </MUISelect>

                    <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                        Quantité :
                    </Typography>
                    <MUITextField value={count} onChange={(e) => setCount(e.target.value)} label="Quantité" />

                    <div style={buttonContainer}>
                        <MUIButton onClick={handleClose} style={buttonStyle} variant="outlined" color="error">
                            Quitter
                        </MUIButton>
                        <MUIButton onClick={() => addProduct(record.id, productId, count, handleClose)} style={buttonStyle} variant="contained" color="success">
                            Ajouter
                        </MUIButton>
                    </div>

                </Box>
            </Modal>
        </div>
    );
}